import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { FileSelectorModel } from '@features/file-manager/models/file-selector.model';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import {DialogService} from '@shared/services/dialog-service';

@Injectable({
  providedIn: 'root',
})

export class AddRemoveQnrCommandHandler implements IPlatformCommandHandler {
  constructor(
    protected dialogService: DialogService,
    private platformQueryService: PlatformQueryService,
    private splashScreenService: FuseSplashScreenService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const parentId = command.fieldValues['ParentId'];
    const selectedQnrIdList = command.fieldValues['QnrIdList'];
    const fileExtensionTypes = command.fieldValues['FileExtensionTypes'];
    const isClientDrive = command.fieldValues['IsClientDrive'];
    const directoryEntryId = command.fieldValues['DirectoryEntryId'];
    const selectOnlyCurrentDirectoryFiles = command.fieldValues['SelectOnlyCurrentDirectoryFiles'] as boolean;
    let title = command.fieldValues['Title'];
    if (parentId) {
      const fileSelector: FileSelectorModel = {
        parentId,
        isClientDrive,
        fileExtensionTypes,
        iconViewModels: [],
        selectOnlyCurrentDirectoryFiles
      };
      this.splashScreenService.show();
      this.getItemList(fileSelector, selectedQnrIdList).subscribe(response => {
        this.splashScreenService.hide();
        const iconViewModels = response.fieldValues['IconViewModels'];
        fileSelector.iconViewModels = iconViewModels;
        this.dialogService.showOrbitaxDriveFileSelector(fileSelector).subscribe(result => {
          if (result.action === 'OK') {
            command.fieldValues['PreviousSelectedItems'] = selectedQnrIdList;
            command.fieldValues['SelectedQnrIdList'] = result.data.input.selectedItems.map(item => item.itemId);
            command.fieldValues['SelectedQnrNameList'] = result.data.input.selectedItems.map(item => item.name);
            command.fieldValues['Title'] = title;
            command.fieldValues['ParentId'] = result.data.input.parentId;
            command.fieldValues['DirectoryEntryId'] = directoryEntryId;
            handler.executeCommand(command);
            return true;
          }
        });
      })
    }
    return true;
  }

  getItemList(fileSelectorModel: FileSelectorModel, idList: string[]) {
    const query = new PlatformQuery();
    query.name = 'IconViewQuery';
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues['ParentId'] = fileSelectorModel.parentId;
    query.fieldValues['IsClientDrive'] = fileSelectorModel.isClientDrive;
    query.fieldValues['FileExtensionTypes'] = fileSelectorModel.fileExtensionTypes;
    query.fieldValues['SelectedDirectoryEntryIdList'] = idList;
    return this.platformQueryService.executeQuery(query).pipe(take(1));
  }
}
